import React from "react";
import {useTranslation} from "react-i18next";
import {useCustomerContext} from "../../../customer/CustomerContextProvider/CustomerContextProvider";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";

const SummaryNewsletter: React.FC = () => {
  const {t} = useTranslation("checkout");
  const {customer} = useCustomerContext();
  const {checkout} = useCheckoutContext();

  if (customer.newsletterFlag || checkout.isGuest) {
    return null;
  }

  const onChecked = (evt: React.ChangeEvent<HTMLInputElement>) =>
    void checkout.put({hasNewsletter: evt.target.checked});

  return (
    <React.Fragment>
      <div className="SimpleRadioList ArrowBorder">
        <div className="SimpleRadioList__Row">
          <label htmlFor="NewsletterOption">
            <div className="SimpleRadioList__Row__Radio">
              <input
                type="checkbox"
                name="newsletter"
                id="NewsletterOption"
                defaultChecked={checkout.hasNewsletter}
                onChange={onChecked}
              />
            </div>
            <p style={{lineHeight: "1.6"}}>
              {t("Ja, ich möchte den Connox Newsletter kostenlos abonnieren. Die Abmeldung ist jederzeit möglich.")}
            </p>
          </label>
        </div>
      </div>
      <br />
    </React.Fragment>
  );
};

export default SummaryNewsletter;
